import React, { useState } from 'react';
import { useThemeContext } from '../../../hook/useThemeManager';
import { theme } from '../../../constants/theme';
import { Toolbar } from '@mui/material';
import { EsFiltersScreenMobile } from './EsFiltersScreenMobile';
import { DiscoveryFilter, FilterItem } from '../../../data/filters/discovery.data';
import { useDispatch, useSelector } from 'react-redux';
import { currentFilterCategorySelector, filterSubCategoryIdSelector } from '../../../selectors/selectors';
import { FilterValueSet } from '../../../redux/appConfigurator/types';
import { toggleDrawer, toggleFiler } from '../../../redux/appConfigurator/action';
import { MapModal } from '../../MapModal/MapModal';
import { IProgressBar, ProgressBar } from '../../ProgressBar/ProgressBar';
import FilterIcon from '../../CustomSVGIcons/FilterIcon';

export interface IEsFilterMobile extends IProgressBar {
    filterList: DiscoveryFilter[];
    onChangeFilterCategory: (filter: FilterItem) => void;
    onChangeFilterSubCategory: (filter: FilterItem, categoryId: number) => void;
    filterSelections: FilterValueSet;
    onClearFilter: () => void;
    disableFilter: boolean;
    onApplyFilterPressed?: () => void;
    isProjectProcessing?: boolean;
}

const EsFiltersMobile: React.FC<IEsFilterMobile> = props => {
    // Theme styles
    const {
        filterList,
        onChangeFilterCategory,
        onChangeFilterSubCategory,
        filterSelections,
        onClearFilter,
        disableFilter,
        onApplyFilterPressed,
        isProjectProcessing,
    } = props;
    const { themeStyle, device } = useThemeContext();
    const selectedCategory = useSelector(currentFilterCategorySelector);
    const selectedFilterSubCategoryId = useSelector(filterSubCategoryIdSelector);
    const dispatch = useDispatch();

    // Open and close filters Screen
    const [filtersScreen, setFiltersScreen] = React.useState<boolean>(false);
    const [openMap, setOpenMap] = useState(false);

    const handleFiltersScreen = () => {
        setFiltersScreen(!filtersScreen);
    };

    const onSaveClick = () => {
        if (onApplyFilterPressed) onApplyFilterPressed();
        handleFiltersScreen();
    };

    const handleFilterSubCategory = (filter: FilterItem, categoryId: number) => {
        onChangeFilterSubCategory(filter, categoryId);
        dispatch(
            toggleFiler({
                filterStatus: 'off',
                filterId: selectedFilterSubCategoryId === categoryId ? undefined : categoryId,
            }),
        );
        dispatch(toggleDrawer({ status: 'closed' }));
    };

    const handleOnClearFilter = () => {
        onClearFilter();
        handleFiltersScreen();
    };

    const renderPhoneFilter = (
        <FilterIcon
            stroke={theme[themeStyle].logo_color}
            height={'30px'}
            width={'30px'}
            onClick={handleFiltersScreen}
        />
    );

    const renderProgressBar = <ProgressBar {...props} />;

    const handleSetOpenMap = () => {
        setFiltersScreen(!filtersScreen);
        setOpenMap(!openMap);
    };

    const handleChange = (address: string, coord: string[]) => {
        handleFilterSubCategory(
            {
                displayName: address,
                field: 'location',
                parentId: 8,
                value: {
                    longitude: coord[0],
                    latitude: coord[1],
                },
            },
            8,
        );
        handleSetOpenMap();
    };

    return (
        <Toolbar
            sx={{
                width: '100%',
                height: '78px',
                backgroundColor: theme[themeStyle].pure_black,
                display: 'flex',
                justifyContent: isProjectProcessing ? 'space-between' : 'flex-end',
                alignItems: 'center',
                gap: '8px',
                zIndex: 2,
                mt: 10,
            }}>
            {/* All filters button */}
            {isProjectProcessing && device.isMobile && renderProgressBar}
            {renderPhoneFilter}
            <MapModal
                isOpen={openMap}
                onClose={handleSetOpenMap}
                onSelectClick={({ coord, addressDescription }) => {
                    handleChange(addressDescription, coord);
                }}
            />
            {filtersScreen && (
                <EsFiltersScreenMobile
                    handleFiltersScreen={onSaveClick}
                    onClose={() => setFiltersScreen(false)}
                    filtersScreen={filtersScreen}
                    setOpenMap={handleSetOpenMap}
                    filterList={filterList}
                    openMap={openMap}
                    onChangeFilterCategory={onChangeFilterCategory}
                    selectedCategory={selectedCategory}
                    filterSelections={filterSelections}
                    onClearFilter={handleOnClearFilter}
                    onFilterSelect={(_, selectedFilter, categoryId) => {
                        console.log(selectedFilter, categoryId);
                        handleFilterSubCategory(selectedFilter, categoryId);
                    }}
                    disableFilter={disableFilter}
                />
            )}
        </Toolbar>
    );
};

export { EsFiltersMobile };
